import { render, staticRenderFns } from "./BasicSkeleton.vue?vue&type=template&id=3f6571e2"
import script from "./BasicSkeleton.vue?vue&type=script&lang=js"
export * from "./BasicSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports